import script from "./TrendAngleTool.vue?vue&type=script&lang=js"
export * from "./TrendAngleTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__